import { createFileRoute } from '@tanstack/react-router';
import Layout from '../components/Layout';
import Logout from '../components/Logout';

function LogoutRoute() {
  return <Layout component={Logout} access={true} />;
}

export const Route = createFileRoute('/logout')({
  component: LogoutRoute,
});
